import api from "./api";
import { defaultUserImg } from "../assets/defaultUser";

export const getAllUsers = async () => {
  const response = await api.get("/UserDetails/GetUserDetails");
  const data = response?.data;

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.resultSet)) return data.resultSet;
  return [];
};

export const uploadProfilePicture = async (serviceNo, file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("ServiceNo", serviceNo);

  const response = await api.post("/User/Fileupload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const getProfilePictureUrl = (serviceNo) => {
  if (!serviceNo) {
    return defaultUserImg;
  }

  return `https://aeroviewbackend.dockyardsoftware.com/User/GetUserImg?Sno=${serviceNo}`;
};

export const getUserWithImage = async (serviceNo) => {
  const users = await getAllUsers();
  const user = users.find((u) => u.ServiceNo === serviceNo);

  if (!user) return null;

  if (user.file_path || user.ImageFile) {
    return {
      ...user,
      profilePicUrl: getProfilePictureUrl(serviceNo),
    };
  }

  return user;
};

export const updateUserMobileNumber = async (serviceNo, newMobileNumber) => {
  const payload = [
    {
      ServiceNo: serviceNo,
      MobileNo: newMobileNumber,
    },
  ];

  const response = await api.post("/UserRegister/PostUserDetails", payload);
  return response.data;
};
